import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import logoBlue from 'assets/images/logo-blue.png';
import { status } from 'constants/general';
import accountManagementStrings from 'modules/accountManagement/strings';
import { loginValidationErrorType } from 'modules/accountManagement/enum';
import Loader from 'modules/common/components/Loader';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  LoginWrapper,
  LoginContent,
  LoginLogo,
  LoginInputLabel,
  LoginInput,
  LoginValidationErrMsg,
  LoginBtn,
  extendLoaderStyle,
} from './LoginComponent.style';

const LoginComponent = ({
  formFieldsValues,
  formFieldsValidation,
  handleInputFieldChange,
  handleSubmitBtnClick,
}) => {
  const userAuthenticationInfo = useSelector(
    state => state.accountManagement.userAuthenticationInfo,
  );

  return (
    <LoginWrapper>
      <LoginLogo src={logoBlue} />
      <SectionDivider gap={80} />
      <LoginContent>
        <LoginInputLabel>{accountManagementStrings.login.emailFieldPlaceholder}</LoginInputLabel>
        <LoginInput
          id="email-login-input"
          value={formFieldsValues.email}
          placeholder={accountManagementStrings.login.emailFieldPlaceholder}
          onChange={event => handleInputFieldChange('email', event)}
        />
        {formFieldsValidation.email === loginValidationErrorType.empty && (
          <LoginValidationErrMsg>
            {accountManagementStrings.login.emailFieldValidationErrorEmpty}
          </LoginValidationErrMsg>
        )}
        {formFieldsValidation.email === loginValidationErrorType.wrong && (
          <LoginValidationErrMsg>
            {accountManagementStrings.login.emailFieldValidationErrorWrong}
          </LoginValidationErrMsg>
        )}
        <SectionDivider gap={25} />
        <LoginInputLabel>{accountManagementStrings.login.passwordFieldPlaceholder}</LoginInputLabel>
        <LoginInput
          id="password-login-input"
          value={formFieldsValues.password}
          placeholder={accountManagementStrings.login.passwordFieldPlaceholder}
          type="password"
          onChange={event => handleInputFieldChange('password', event)}
        />
        {formFieldsValidation.password === loginValidationErrorType.empty && (
          <LoginValidationErrMsg>
            {accountManagementStrings.login.passwordFieldValidationErrorEmpty}
          </LoginValidationErrMsg>
        )}
        <SectionDivider gap={45} />
        {(userAuthenticationInfo.status === status.FETCHING && (
          <Loader extendStyle={extendLoaderStyle} width={30} height={30} thickness={5} />
        )) || (
          <>
            <LoginBtn as="button" onClick={() => handleSubmitBtnClick()}>
              {accountManagementStrings.login.loginBtn}
            </LoginBtn>
            {userAuthenticationInfo.status === status.FAIL && (
              <LoginValidationErrMsg>
                {accountManagementStrings.login.wrongCredentials}
              </LoginValidationErrMsg>
            )}
          </>
        )}
      </LoginContent>
    </LoginWrapper>
  );
};

LoginComponent.propTypes = {
  formFieldsValues: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  formFieldsValidation: PropTypes.shape({
    email: PropTypes.number,
    password: PropTypes.number,
  }).isRequired,
  handleInputFieldChange: PropTypes.func.isRequired,
  handleSubmitBtnClick: PropTypes.func.isRequired,
};

LoginComponent.defaultProps = {};

export default LoginComponent;
